<template>
    <div class="footer_div">
        <div class="footer_div_dom">
            <div class="item_one">
                <ul class="dh_ul">    
                    <li @click="goPage('/')" title="首页">
                        首页
                    </li>
                    <li class="xian" @click="goPage('/about')" title="关于我们">
                        关于我们
                    </li>
                    <li class="xian" @click="goPage('/contactUs')" title="联系我们">
                        联系我们
                    </li>
                    <li class="xian" @click="goPage('/agreement')" title="用户协议">
                        用户协议
                    </li>
                    <li class="xian" @click="goPage('/privacy')" title="隐私政策">
                        隐私政策
                    </li>
                    <div class="clear"></div>
                </ul>

                <p class="p_text">
                    <span>
                        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010993" target="_blank">
                            <img src="https://zyprogram.xinchacha.com/assets/img/gongan.png" style="vertical-align: middle;"> 
                            京公网安备11011402010993号
                        </a>
                    </span>
                    <span>
                        京ICP备19041340号-2
                    </span>
                    <span>
                        <a data-v-0e2cac02="" target="_blank" href="https://dxzhgl.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%25E4%25BA%25ACB2-20210254&amp;type=xuke">
                            增值电信业务经营许可证:京B2-20210254
                        </a>
                    </span>
                    
                </p>
            </div>
            <div class="item_twe">
                <div class="item_twe_1">
                    <p class="txt">北京热线</p>
                    <h3>400 900 6808</h3>
                    <div class="time_dom">周一至周五 9:00-18:00</div>
                </div>
                <div class="item_twe_2">
                    <div class="erweima">
                        <img src="https://zyprogram.xinchacha.com/xiansuo/pc/erweima.jpg" alt="" srcset="">
                    </div>
                    <p class="erweima_txt">公众号</p>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'vFooter',
    data(){
        return{

        }
    },
    methods:{
        goPage(ourl){
            return this.$router.push({
                path:ourl
            });
        }
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.footer_div{
    width: 100%;
    height: auto;
    background-color: #1E282D;
    padding: 52px 0;
    >div.footer_div_dom{
        height: auto;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        @media screen and (max-width: 1400px){
            width: 960px;
        }
        @media screen and (min-width: 1400px){
            width: 1200px;
        }
        >div.item_one{
            width: 52%;
            height: auto;
            >ul.dh_ul{
                width: 100%;
                height: auto;
                margin: 0 auto;
                >li{
                    width: 25%;
                    line-height: 22px;
                    height: auto;
                    float: left;
                    text-align: center;
                    box-sizing: border-box;
                    list-style-type: none;
                    font-size: 16px;
                    font-weight: 600;
                    color: rgba(255, 255, 255, 0.7);
                    cursor: default;
                    >a{
                        font-size: 16px;
                        font-weight: 600;
                        color: rgba(255, 255, 255, 0.7);
                        text-decoration: none;
                    }
                }
                >li.xian{
                    border-left: 1px solid rgba(255, 255, 255, 0.7);
                }
            }
            >p.p_text{
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 13px;
                color: rgba(255, 255, 255, 0.58);
                text-align: center;
                margin-top: 30px;
                cursor: default;
                >span{
                    line-height: 20px;
                    font-size: 13px;
                    color: rgba(255, 255, 255, 0.58);
                    >a{
                        color: rgba(255, 255, 255, 0.58);
                        text-decoration: none;
                        >img{
                            width: 13px;
                        }
                    }
                }
            }
        }
        >div.item_twe{
            height: auto;
            color: #FFFFFF;
            @media screen and (max-width: 1400px){
                width: 40%;
            }
            @media screen and (min-width: 1400px){
                width: 34%;
            }
            >.item_twe_1{
                width: calc(100% - 100px);
                height: auto;
                float: left;
                color: #FFFFFF;
                >p.txt{
                    width: 100%;
                    height: 20px;
                    font-size: 16px;
                    color: #FFFFFF;
                    line-height: 22px;
                    margin-bottom: 20px;
                    cursor: default;
                }
                >h3{
                    font-size: 36px;
                    font-weight: 600;
                    color: #FFFFFF;
                    cursor: default;
                    margin-bottom: 10px;
                }
                >div.time_dom{
                    width: 100%;
                    height: 20px;
                    line-height: 20px;
                    font-size: 14px;
                    color: #FFFFFF;
                    font-weight: 400;
                    text-align: left;
                    cursor: default;
                }
            }
            >.item_twe_2{
                width: 100px;
                height: auto;
                float: left;
                color: #FFFFFF;
                >div.erweima{
                    width: 100px;
                    height: 100px;
                    background-color: #FFFFFF;
                    margin-bottom: 13px;
                    >img{
                        width: 100%;
                        height: auto;
                        display: block;
                    }
                }
                >p.erweima_txt{
                    width: 100%;
                    font-size: 14px;
                    color: #FFFFFF;
                    font-weight: 400;
                    text-align: center;
                    cursor: default;
                }
            }
        }
    }
}
.clear{
    width: 100%;
    height: 1px;
    clear: both;
}
</style>


// WEBPACK FOOTER //
// src/components/common/footer.vue